import { render, staticRenderFns } from "./ReportGeneral.vue?vue&type=template&id=4f2a50fa&scoped=true"
import script from "./ReportGeneral.vue?vue&type=script&lang=js"
export * from "./ReportGeneral.vue?vue&type=script&lang=js"
import style0 from "./ReportGeneral.vue?vue&type=style&index=0&id=4f2a50fa&prod&lang=scss&scoped=true"
import style1 from "./ReportGeneral.vue?vue&type=style&index=1&id=4f2a50fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a50fa",
  null
  
)

export default component.exports